import { config } from '../Config';
import { adalApiFetch } from '../adalConfig';

const encodeEndpoint = (path: string) => (window as any).encodeURI(config.apiUrl + path);

export default class APILayer {
    get = async (path: string) => {
        return adalApiFetch(fetch, encodeEndpoint(path), {
            method: 'GET',
            credentials: 'include',
        });
    };

    post = async (path: string, body: any, formData: boolean = false) => {
        const options: RequestInit = {
            method: 'POST',
            credentials: 'include',
            body: formData ? body : JSON.stringify(body),
        };

        if (!formData) {
            options.headers = {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
            };
        }

        return adalApiFetch(fetch, encodeEndpoint(path), options);
    };

    put = async (path: string, body: any) => {
        return adalApiFetch(fetch, encodeEndpoint(path), {
            method: 'PUT',
            credentials: 'include',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
    };
}
